import Constants from './constants';
import FeaturePermissionsHelper from './feature_permissions_helper';

const {
  FUNCTIONALITY_ACL_FEATURE_CODE_ADVANCED_CUSTOMERS_LIST,
  FUNCTIONALITY_ACL_FEATURE_CODE_STEP4_ACCESS,
  USER_SETTING_VALUES,
  USER_TYPES,
} = Constants;

const { USER_TYPE_CPF } = USER_TYPES;
const {
  USER_SETTING_VALUE_CPF_AM_SUPER_USER,
  USER_SETTING_VALUE_CPF_AM_TEAM_LEAD,
  USER_SETTING_VALUE_CPF_CREDIT_ANALYST,
} = USER_SETTING_VALUES;
const USER_SETTING_VALUE_ENABLED = '1';

export default class FunctionalityAccessHelper {
  static findUserSettingValueBySettingAndValue(userSettingValues, setting, value) {
    return userSettingValues.filter(({ setting: s }) => setting === s).find(({ value: v }) => value === v) || null;
  }

  static getUserSettingValueByName(name, user) {
    return user?.userSettingValues?.find(({ setting }) => setting === name)?.value;
  }

  static hasAccessToAdmin(user) {
    // return true;
    return user && (user.atype === 'A' || user.atype === 'CPF' || FeaturePermissionsHelper.hasModule(user, 'admin'));
  }

  static hasAccessToAdvancedCustomersList(userFunctionalityAcls) {
    return (
      userFunctionalityAcls != null &&
      this.hasACL(userFunctionalityAcls, FUNCTIONALITY_ACL_FEATURE_CODE_ADVANCED_CUSTOMERS_LIST)
    );
  }

  static hasAccessToEscalatedStepDocs(userType, userSettingValues) {
    return (
      userType === USER_TYPE_CPF &&
      FunctionalityAccessHelper.findUserSettingValueBySettingAndValue(
        userSettingValues,
        USER_SETTING_VALUE_CPF_AM_TEAM_LEAD,
        USER_SETTING_VALUE_ENABLED
      ) !== null
    );
  }

  static hasAccessToLockForEditing(lockedForEditingByUserId, user, userSettingValues) {
    return (
      user &&
      (user.id === lockedForEditingByUserId ||
        FunctionalityAccessHelper.findUserSettingValueBySettingAndValue(
          userSettingValues,
          USER_SETTING_VALUE_CPF_AM_SUPER_USER,
          USER_SETTING_VALUE_ENABLED
        ) !== null)
    );
  }

  static hasAccessToStep4(userFunctionalityAcls, step4ProductElement) {
    return (
      userFunctionalityAcls !== null &&
      this.hasACL(userFunctionalityAcls, FUNCTIONALITY_ACL_FEATURE_CODE_STEP4_ACCESS) &&
      step4ProductElement !== null &&
      step4ProductElement.defaultValue === USER_SETTING_VALUE_ENABLED
    );
  }

  static hasAccessToTier1StepDocs(userType, userSettingValues) {
    return (
      userType === USER_TYPE_CPF &&
      (FunctionalityAccessHelper.findUserSettingValueBySettingAndValue(
        userSettingValues,
        USER_SETTING_VALUE_CPF_AM_TEAM_LEAD,
        USER_SETTING_VALUE_ENABLED
      ) !== null ||
        FunctionalityAccessHelper.findUserSettingValueBySettingAndValue(
          userSettingValues,
          USER_SETTING_VALUE_CPF_CREDIT_ANALYST,
          USER_SETTING_VALUE_ENABLED
        ) !== null)
    );
  }

  static hasAccessToTier2StepDocs(userType, userSettingValues) {
    return (
      userType === USER_TYPE_CPF &&
      FunctionalityAccessHelper.findUserSettingValueBySettingAndValue(
        userSettingValues,
        USER_SETTING_VALUE_CPF_AM_TEAM_LEAD,
        USER_SETTING_VALUE_ENABLED
      ) !== null
    );
  }

  static hasHideValueProps(userFunctionalityAcls) {
    return this.hasACL(userFunctionalityAcls, Constants.FUNCTIONALITY_ACL_FEATURE_CODE_HIDE_VALUE_PROPS);
  }

  static hasAccessToDisbursements(userFunctionalityAcls) {
    return this.hasACL(userFunctionalityAcls, Constants.FUNCTIONALITY_ACL_FEATURE_CODE_REPORTING_DISBURSEMENT);
  }

  static canRequestFunding(userType, userFunctionalityAcls) {
    return (
      userType === USER_TYPE_CPF ||
      this.hasACL(userFunctionalityAcls, Constants.FUNCTIONALITY_ACL_FEATURE_CODE_REQUEST_FUNDING)
    );
  }

  static hasRewindStep(userFunctionalityAcls) {
    return this.hasACL(userFunctionalityAcls, 'STEP_REWIND');
  }

  static hasAccessToBorrowerInfo(userFunctionalityAcls) {
    return this.hasACL(userFunctionalityAcls, Constants.FUNCTIONALITY_ACL_RETRIEVE_BORROWER_INFO);
  }

  static hasACL(userFunctionalityAcls, aclName) {
    return (userFunctionalityAcls || []).some(({ featureCode }) => featureCode === aclName);
  }
}
